import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCustomerAuth } from "@/hooks/useCustomerAuth";
import { supabase } from "@/integrations/supabase/client";

/**
 * Globally checks for a pending (unscratched) scratch card on app open/resume.
 * Navigates to the booking detail page with ?openScratch=1 if one is found.
 * Skips the check when already on a booking detail page to avoid redirect loops.
 */
export function useGlobalScratchCardCheck() {
  const { customer } = useCustomerAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!customer?.id) return;
    // Don't redirect if already on booking detail — CustomerBookingDetail handles it
    if (location.pathname.startsWith("/customer/booking/")) return;

    supabase
      .from("customer_scratch_cards")
      .select("id, booking_id")
      .eq("customer_id", customer.id)
      .eq("is_scratched", false)
      .eq("is_redeemed", false)
      .gt("expires_at", new Date().toISOString())
      .order("created_at", { ascending: false })
      .limit(1)
      .maybeSingle()
      .then(({ data }) => {
        if (data?.booking_id) {
          setTimeout(() => {
            navigate(`/customer/booking/${data.booking_id}?openScratch=1`, { replace: false });
          }, 300);
        }
      });
  }, [customer?.id, location.pathname, navigate]);
}
